<template>
  <div>
    <CreateTaskForm
      :user="user"
      :date="date"
      :theNewlyCreatedSubject="theNewlyCreatedSubject"
      :showSubstituteOption="showSubstituteOption"
      @setDate="setDate"
      @close="$emit('close')"
      @createNewSubject="setCreateNewSubject($event)"
      @onCreatedEvent="onCreatedEvent">
    </CreateTaskForm>
    <CreateTaskNewSubject
      v-if="theCreateNewSubjectName"
      :user="user"
      :date="date"
      :title="theCreateNewSubjectName"
      @newSubject="onNewSubject"
      @close="setCreateNewSubject(null)">
    </CreateTaskNewSubject>
  </div>
</template>
<script>
import CreateTaskForm from './CreateTaskForm.vue'
import CreateTaskNewSubject from './CreateTaskNewSubject.vue'
import moment from 'moment'

export default {
  components: {CreateTaskNewSubject, CreateTaskForm},
  props: {
    user: {
      type: Object,
      default: null
    },
    initDate: {
      type: Object,
      default: moment()
    },
    emitEvent: {
      type: Boolean,
      default: false
    },
    showSubstituteOption: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      date: moment(),
      theCreateNewSubjectName: null,
      theNewlyCreatedSubject: null
    }
  },
  methods: {
    onCreatedEvent (lesson) {
      // Antag at this.initDate er i ISO 8601 format
      const initDate = this.initDate

      // Start og slutdato fra eventet
      const eventStart = lesson.start
      const eventEnd = lesson.end

      // Brug moment.js til at konvertere datoerne til moment objekter
      const initDateMoment = moment(initDate)
      const eventStartMoment = moment(eventStart)
      const eventEndMoment = moment(eventEnd)

      // Tjek om både start og slutdatoer matcher initDate
      const isStartDateSame = eventStartMoment.isSame(initDateMoment, 'day')
      const isEndDateSame = eventEndMoment.isSame(initDateMoment, 'day')
      if (this.emitEvent) {
        this.$emit('addANewEvent', lesson)
        return
      }
      if (isStartDateSame && isEndDateSame) {
        this.$store.commit('addANewEvent', lesson)
      }
    },
    setDate (mom) {
      this.date = mom
    },
    setCreateNewSubject (str) {
      this.theCreateNewSubjectName = str
    },
    onNewSubject (subject) {
      this.theNewlyCreatedSubject = subject
      this.setCreateNewSubject(null)
    }
  },
  beforeMount () {
    this.date = this.initDate
  }
}
</script>



// WEBPACK FOOTER //
// CreateTask.vue?30a1bc94